import { useState } from 'react'
import { useDebouncedValue } from '@/hooks/use-debounced-value.ts'

export function useRemoteKeyword() {
  const [keyword, setKeyword] = useState('')
  return { keyword: useDebouncedValue(keyword), onSearch: setKeyword }
}
